import script from "./MsSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsSearch.vue?vue&type=script&setup=true&lang=ts"

import "./MsSearch.vue?vue&type=style&index=0&id=1956a079&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1956a079"]])

export default __exports__